import numeral from 'numeral'

const type = new Map([
  [1, '信用限额'],
  [2, '正常额度'],
  [3, '临时额度'],
  [4, '专项额度'],
  [5, '信用限额 + 正常额度'],
  [6, '信用限额 + 临时额度'],
  [7, '信用限额 + 专项额度'],
  ['default', ''],
])

const formatBussniessType = val => {
  return type.get(Number(val))
}

const formatApplyStatus = num => {
  const status = new Map([
    [0, '待审核'],
    [1, '待审批'],
    [2, '成功'],
    [3, '失败'],
  ])
  return status.get(num)
}

const formatAmount = num => {
  return numeral(num).format('0,0.00')
}

const formatInt = num => {
  return numeral(num).format() // 调用默认的"0,0"
}

const department = num => {
  const str = {
    '1': '技术',
    '2': '商务',
    '3': '信用',
    '4': '业务',
    '5': '其他',
  }
  return str[num]
}

const creditType = num => {
  const str = new Map([
    [1, '正常额度'],
    [2, '短期信用'],
    [3, '专项信用'],
  ])
  return str.get(num)
}

const assignmentStatus = num => {
  const status = new Map([
    [1, '生效中'],
    [2, '已取消'],
    [3, '已失效'],
  ])
  return status.get(num)
}

const formatTypeList = num => {
  const type = new Map([
    [1, '企业基本信息'],
    [2, '企业主要联系人'],
    [3, '企业额外信息'],
    [4, '企业外部评分信息'],
    [5, '评分卡财报数据'],
    [6, '企业账户信息'],
    [7, '担保及保险'],
    [8, '融资数据'],
    [23, '内外部评级转化'],
    [25, '信用评级'],
  ])
  return type.get(num)
}

const riskTypeFilter = num => {
  if (!num && num !== 0) return ''
  const riskTypeMap = new Map([
    [1, '一般审批'],
    [2, '高风险审批'],
  ])
  return riskTypeMap.get(Number(num)) || ''
}

export default {
  formatTypeList,
  assignmentStatus,
  creditType,
  department,
  formatAmount,
  formatInt,
  formatApplyStatus,
  // formatAppAmount,
  formatBussniessType,
  riskTypeFilter,
}
